<template>
    <div class="grid mt-1"> 
      <Loader v-if="loader" />
      <div class="col">
        <Accordion class="mb-3 filter-estratti-conto">
          <AccordionTab>
            <template #header>
              <i class="pi pi-calendar" style="font-size: 1.3rem"></i>
              &nbsp; Cambia periodo
            </template>
            <div class="p-fluid grid formgrid text-left">
              <div class="field col-12">
                <Calendar v-model="periodo_riferimento" dateFormat="yy-mm-dd" :showIcon="true" selectionMode="range" placeholder="Seleziona periodo" />
              </div>
              <div class="field col-12"> 
                <Button 
                @click="changeData" 
                label="Prova periodo" 
                class="p-button-primary"
                :disabled="!periodo_riferimento" 
                />
              </div>
            </div>  
          </AccordionTab>
        </Accordion>
      </div>

      <div class="col">
        <Accordion class="mb-3 filter-estratti-conto">
          <AccordionTab>
            <template #header>
              <i class="pi pi-sort-numeric-down" style="font-size: 1.3rem"></i>
              &nbsp; Prova combinazioni
            </template>
            <div class="p-fluid grid formgrid text-left">
              <div class="field col-12">
                <Button 
                @click="getCombinationsRid" 
                label="Prova combinazioni" 
                class="p-button-primary"
                />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>

      <div class="col" v-if="isVisibleReverseBox()">
        <Accordion class="mb-3 filter-estratti-conto">
          <AccordionTab>
            <template #header>
              <i class="pi pi-filter-slash" style="font-size: 1.3rem"></i>
              &nbsp; Prova reverse
            </template>
            <div class="p-fluid grid formgrid text-left">
              <div class="field col-12">
                <Button 
                @click="getRidsToDiscard" 
                label="Prova reverse" 
                class="p-button-primary"
                />
                <div class="mt-1 text-center text-400"><small>Potrebbe richiedere un pò di tempo</small></div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>

      <div class="col" v-if="estrattoConto.type_pay_mode_name == 'MPS'">
        <Accordion class="mb-3 filter-estratti-conto">
          <AccordionTab>
            <template #header>
              <i class="pi pi-file" style="font-size: 1.3rem"></i>
              &nbsp; Carica file
            </template>
            <div class="p-fluid grid formgrid w-full">
              <div class="form-file w-full">
                <div class="field col-12">
                  <div class="button-wrapper">
                    <span class="label">
                      {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
                    </span>
                    <input id="upload" :key="keyResetInput" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
                  </div>
                  <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
                  <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
                  <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
              </div>
              </div>
              <div class="field col-12"> 
                <small class="text-400 mb-1">Se ci sono dati disponibili questo autoselezionerà le fatture corrispondenti</small>
                <div class="flex gap-2 mt-1">
                  <Button 
                  @click="checkPreImport" 
                  label="Check" 
                  class="p-button-secondary"
                  />
                  <Button 
                  @click="selectedSameItemsIntoFile" 
                  label="Carica" 
                  class="p-button-primary"
                  :loading="loadingFile"
                  :disabled="loadingFile"
                  />
                </div>
              </div>
            </div>  
          </AccordionTab>
        </Accordion>
      </div>

      <div class="col-12" v-if="(combinations.length == 1 && combinations[0].length == 1 && payments.length > 0) || (combinations.length > 0 && estrattoConto.suggestRid == 1 )">
        <h6>Scegli una delle seguenti combinazioni trovate</h6>
        <div class="grid">
          <div v-for="combo in combinations" :key="combo.id" class="col-12 md:col-3 flex justify-content-center">
              <Button @click="injectCombo(combo)" class="p-button-raised p-button-warning w-10 justify-content-center p-3 text-white">
                {{combo.length}} elementi
              </Button>
          </div>
        </div>
        <!-- <div class="flex justify-content-end">
          <div @click="getCommonPayments" class="help-combo"> Trova fatture comuni</div>
        </div> -->
      </div>

      <div class="col-12">
        <div v-if="payments.length > 0">

          <DataTable dataKey="id" ref="dt" :value="payments" v-model:selection="selectedPayments" :filters="filters"  responsiveLayout="scroll" :scrollable="true" scrollHeight="400px">
              <template #header>
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                    </span>
                    <div class="mt-2">
                      Totale elementi: {{selectedPayments.length}} di {{payments.length}}
                    </div>
                    
                  </div>
                  <div class="col-12 md:col-6 flex flex-column">
                    <div class="field-checkbox flex justify-content-end">
                      <Checkbox @change="filterTypeFlusso" value="CORE" v-model="selectedTypeFlusso" />
                      <label class="m-2">CORE</label>
                      <Checkbox @change="filterTypeFlusso" value="B2B" v-model="selectedTypeFlusso" />
                      <label class="m-2">B2B</label>
                    </div>
                    <div class="flex justify-content-end">
                       <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                    </div>
                  </div>
                </div>
              </template>

              <Column selectionMode="multiple" headerStyle="width: 1rem"></Column>
              <Column field="numero" header="Numero" :sortable="true" />
              <Column field="cliente" header="Cliente" :sortable="true" />
              <Column field="value"  header="Totale" :sortable="true">
                <template #body="{data}">
                    <p class="text-primary">
                      {{data.value.toFixed(2)}}
                    </p> 
                </template>
              </Column>
              <Column field="data" header="Data" :sortable="true" />
              <Column field="flusso" header="Flusso" :sortable="true" />
          </DataTable>

          <div class="chip-selected-suggest mt-3 p-fluid">
            <Chips v-model="selectedPayments" @keypress.prevent="false">
              <template #chip="slotProps">
                  <div class="chip-basic">
                      <div class="title-chip">{{slotProps.value.numero}}</div>
                      <span style="font-size: 12px">€ {{slotProps.value.value.toFixed(2)}}</span>
                  </div>
              </template>   
            </Chips>
          </div>

          <div class="my-2 md:mt-0 flex align-items-center">
            <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
              <div 
              class="p-bar h-full" 
              :style="{ width: percentage +'%'}"
              :class="(percentage == 100) ? 'bg-blue-500' : (percentage > 100) ? 'bg-red-500': 'bg-yellow-500'"
              >
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col-4 flex justify-content-start">
              <div class="text-left">
                <p class="title-bar">ASSOCIATO</p>
                <b  class="num-bar text-yellow-500">{{selectedSum.toFixed(2)}}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-center">
              <div class="text-left">
                <p class="title-bar">RIMANENTI</p>
                <b class="num-bar p-error">{{( Math.abs(estrattoConto.value) - selectedSum).toFixed(2)}}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-end">
              <div class="text-left">
                <p class="title-bar">TOTALE</p>
                <b class="num-bar text-blue-500">{{estrattoConto.value}} </b> &euro;
              </div>
            </div>
          </div> 

          <div class="mt-3 text-right">
              <Button 
              @click="associa" 
              label="Associa movimento" 
              class="p-button-outlined" 
              :disabled="selectedSum.toFixed(2) != Math.abs(estrattoConto.value)" 
              :class="selectedSum.toFixed(2) != Math.abs(estrattoConto.value) ? 'p-button-secondary' : ' p-button-primary'" 
              />
          </div>        
        </div>

        <div v-else>
          <div v-if="combinations.length == 0">
            <h6 class="p-error text-center">NESSUN DATO DISPONIBILE</h6>
          </div>
        </div>

      </div>
   </div>

    <Dialog
      v-model:visible="checkDialog"
      :modal="true"
      :dismissableMask="true"
      :showHeader="false"
      :style="{ width: '92vw', maxWidth: '1200px' }"
      :breakpoints="{ '960px': '96vw' }"
      class="check-pre-import-dialog"
      contentClass="check-dialog-content"
    >
      <div v-if="checkResult" class="check-dialog">
        <header class="check-dialog__header">
          <div class="check-dialog__heading">
            <p class="check-dialog__eyebrow">Verifica file</p>
            <h3 class="check-dialog__title">Esito check pre-import</h3>
            <p class="check-dialog__subtitle">
              Controlla le righe associabili e quelle che richiedono intervento.
            </p>
          </div>
          <button type="button" class="check-dialog__close" aria-label="Chiudi" @click="checkDialog = false">
            <i class="pi pi-times"></i>
          </button>
        </header>

        <section class="check-dialog__stats" aria-label="Riepilogo">
          <div class="check-stat check-stat--hero check-stat--ok">
            <span class="check-stat__label">Associabili</span>
            <span class="check-stat__value">{{ checkResult.totals?.ok ?? 0 }}</span>
            <span class="check-stat__hint">Pronte per l'associazione</span>
          </div>
          <div class="check-stat check-stat--ko">
            <span class="check-stat__label">Da verificare</span>
            <span class="check-stat__value">{{ checkResult.totals?.non_ok ?? 0 }}</span>
            <span class="check-stat__hint">Motivi bloccanti o già collegate</span>
          </div>
          <div class="check-stat check-stat--total">
            <span class="check-stat__label">Analizzate</span>
            <span class="check-stat__value">{{ checkResult.totals?.totali ?? 0 }}</span>
            <span class="check-stat__hint">Righe nel file</span>
          </div>
        </section>

        <div class="check-dialog__tabs" role="tablist">
          <button
            type="button"
            role="tab"
            class="check-tab" 
            :class="{ 'is-active': checkActiveTab === 'ok' }"
            :aria-selected="checkActiveTab === 'ok'"
            @click="checkActiveTab = 'ok'"
          >
            <span class="check-tab__dot check-tab__dot--ok"></span>
            OK
            <span class="check-tab__count">{{ checkResult.ok?.length ?? 0 }}</span>
          </button>
          <button
            type="button"
            role="tab"
            class="check-tab"
            :class="{ 'is-active': checkActiveTab === 'non_ok' }"
            :aria-selected="checkActiveTab === 'non_ok'"
            @click="checkActiveTab = 'non_ok'"
          >
            <span class="check-tab__dot check-tab__dot--ko"></span>
            Non OK
            <span class="check-tab__count">{{ checkResult.non_ok?.length ?? 0 }}</span>
          </button>
        </div>

        <div v-show="checkActiveTab === 'ok'" class="check-dialog__panel" role="tabpanel">
          <DataTable
            v-if="checkResult.ok?.length"
            :value="checkResult.ok"
            dataKey="riga"
            class="check-table"
            responsiveLayout="scroll"
            :scrollable="true"
            scrollHeight="380px"
            paginator
            :rows="8"
            :rowsPerPageOptions="[8, 15, 30]"
          >
            <Column field="riga" header="Riga" style="width: 4.5rem" />
            <Column field="numero" header="Numero">
              <template #body="{ data }">
                <span class="check-mono">{{ data.numero || '-' }}</span>
              </template>
            </Column>
            <Column field="descrizione" header="Descrizione" />
            <Column field="importo" header="Importo">
              <template #body="{ data }">
                <span class="check-mono">{{ data.importo != null ? Number(data.importo).toFixed(2) : '-' }}</span>
              </template>
            </Column>
            <Column field="debitore" header="Debitore" />
            <Column field="esito" header="Esito" />
            <Column field="numero_distinta" header="N. Distinta" />
            <Column field="numero_incasso" header="N. Incasso" />
            <Column field="payment_id" header="Payment">
              <template #body="{ data }">
                <span class="check-mono">{{ data.payment_id ?? '-' }}</span>
              </template>
            </Column>
            <Column field="payment_value" header="Valore">
              <template #body="{ data }">
                <span class="check-mono">{{ data.payment_value != null ? Number(data.payment_value).toFixed(2) : '-' }}</span>
              </template>
            </Column>
            <Column field="payment_data" header="Data" />
          </DataTable>
          <div v-else class="check-empty">
            <i class="pi pi-inbox check-empty__icon"></i>
            <p class="check-empty__title">Nessuna riga associabile</p>
            <p class="check-empty__text">Nel file non risultano fatture pronte per l'associazione.</p>
          </div>
        </div>

        <div v-show="checkActiveTab === 'non_ok'" class="check-dialog__panel" role="tabpanel">
          <DataTable
            v-if="checkResult.non_ok?.length"
            :value="checkResult.non_ok"
            dataKey="riga"
            class="check-table"
            responsiveLayout="scroll"
            :scrollable="true"
            scrollHeight="380px"
            paginator
            :rows="8"
            :rowsPerPageOptions="[8, 15, 30]"
            :rowClass="nonOkRowClass"
            @row-click="onNonOkRowClick"
          >
            <Column field="riga" header="Riga" style="width: 4.5rem" />
            <Column field="numero" header="Numero">
              <template #body="{ data }">
                <span class="check-mono">{{ data.numero || '-' }}</span>
              </template>
            </Column>
            <Column field="descrizione" header="Descrizione" />
            <Column field="importo" header="Importo">
              <template #body="{ data }">
                <span class="check-mono">{{ data.importo != null ? Number(data.importo).toFixed(2) : '-' }}</span>
              </template>
            </Column>
            <Column field="debitore" header="Debitore" />
            <Column field="cod_estrattoconto" header="Estratto conto">
              <template #body="{ data }">
                <button
                  v-if="getCodEstrattoconto(data)"
                  type="button"
                  class="check-ec-link"
                  @click.stop="goToEstrattoConto(data)"
                >
                  <i class="pi pi-external-link"></i>
                  {{ getCodEstrattoconto(data) }}
                </button>
                <span v-else class="check-muted">-</span>
              </template>
            </Column>
            <Column header="Motivi">
              <template #body="{ data }">
                <div v-if="data.motivi?.length" class="check-motivi">
                  <span
                    v-for="(motivo, idx) in data.motivi"
                    :key="idx"
                    class="check-motivo"
                    :class="`check-motivo--${getMotivoSeverity(motivo)}`"
                  >
                    {{ formatMotivo(motivo) }}
                  </span>
                </div>
                <span v-else class="check-muted">-</span>
              </template>
            </Column>
          </DataTable>
          <div v-else class="check-empty">
            <i class="pi pi-check-circle check-empty__icon check-empty__icon--ok"></i>
            <p class="check-empty__title">Tutto in ordine</p>
            <p class="check-empty__text">Nessuna riga richiede interventi aggiuntivi.</p>
          </div>
        </div>
      </div>
    </Dialog>

</template>

<script>
import moment from 'moment'
import { ref, getCurrentInstance, onMounted, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'
import { useToast } from 'primevue/usetoast'
var XLSX = require("xlsx");

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const toast = useToast()
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const dt = ref();
    const validationErrors = ref({})
    const submitted = ref(false)
    const loader = ref(false)
    const estrattoConto = ref(props.detail)
    const payments = ref([])
    const originalPayments = ref([])
    const selectedPayments = ref([])
    const periodo_riferimento = ref([new Date(estrattoConto.value.data_valuta) ?? new Date()]);
    const combinations = ref([]);
    const selectedTypeFlusso = ref()
    const diffLength = ref(0)
    const fileToUpload = ref([])
    const keyResetInput = ref(0)
    const checkResult = ref(null)
    const checkDialog = ref(false)
    const checkActiveTab = ref('ok')
    const loadingFile = ref(false)
    const allowedType = {
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }

    onMounted(() => {
      bootstrapSuggestions()
    })

    const normalizePayments = (items) => {
      if (Array.isArray(items)) return items
      if (Array.isArray(items?.data)) return items.data
      return []
    }

    const bootstrapSuggestions = async (period = null) => {
      const descriptionMatchCount = await getData(period)

      if (descriptionMatchCount > 1) {
        combinations.value = []
        selectedPayments.value = []
        payments.value = [...originalPayments.value]
        return
      }

      if (descriptionMatchCount === 1) {
        return
      }

      await isVisibleReverseBox()
      getCombinationsRid(estrattoConto.value.suggestRid != 1)
    }

    const getData = async (period = null) => {
      loader.value = true
      let obj = { ...estrattoConto.value }
      try {
        const res = await service.getRids(obj, period)
        const list = normalizePayments(res.items)
        payments.value = list
        originalPayments.value = [...list]
        return addInvoiceFromDescription()
      } finally {
        loader.value = false
      }
    }

    const getMatchesFromDescription = (source = payments.value) => {
      const descrizione = String(estrattoConto.value?.descrizione || '')
      if (!source.length || !descrizione) {
        return []
      }
      return source.filter((payment) => {
        const numero = String(payment?.numero || '').trim()
        return numero && descrizione.includes(numero)
      })
    }

    const showSuggestionButton = (combo) => {
      combinations.value = [combo]
      selectedPayments.value = []
    }

    const addInvoiceFromDescription = () => {
      const result = getMatchesFromDescription(originalPayments.value)
      combinations.value = []
      selectedPayments.value = []

      if (result.length === 1) {
        showSuggestionButton(result)
      } else {
        payments.value = [...originalPayments.value]
      }

      return result.length
    }

    const changeData = () => {
      bootstrapSuggestions(buildPeriod())
    }

    const getCombinationsRid = (onlySingle = false) => {
      const descriptionMatches = getMatchesFromDescription(originalPayments.value)
      if (descriptionMatches.length > 1) {
        combinations.value = []
        selectedPayments.value = []
        payments.value = [...originalPayments.value]
        return
      }

      combinations.value = []
      loader.value = true
      let period = buildPeriod()
      let obj = {...estrattoConto.value}

      service.getCombinationsRid(obj, period).then((res)=>{
        if (getMatchesFromDescription(originalPayments.value).length > 1) {
          combinations.value = []
          payments.value = [...originalPayments.value]
          return
        }

        const combos = normalizePayments(res.items)
        if (onlySingle && combos.length !== 1) {
          combinations.value = []
          payments.value = [...originalPayments.value]
          return
        }

        if (combos.length === 0) {
          combinations.value = []
          payments.value = [...originalPayments.value]
          return
        }

        combinations.value = onlySingle ? combos.slice(0, 1) : combos
      }).finally(()=>{
        loader.value = false
      })
    }

    const buildPeriod = () => {
      let data = []
      data[0] = moment(estrattoConto.value.data_valuta).format('YYYY-MM-DD')
      data[1] = moment(estrattoConto.value.data_valuta).format('YYYY-MM-DD')
      if (periodo_riferimento.value) {
        data[0] = moment(periodo_riferimento.value[0]).format('YYYY-MM-DD')
        data[1] = moment(periodo_riferimento.value[0]).format('YYYY-MM-DD')
        if (periodo_riferimento.value.length > 1 && periodo_riferimento.value[1] != null) {
          data[1] = moment(periodo_riferimento.value[1]).format('YYYY-MM-DD')
        }
      }
      
      return data
    }

    const injectCombo = (combo) => {
      selectedPayments.value = combo
      combinations.value = []
    }

    
    const isVisibleReverseBox = async () => {
      diffLength.value = 0
      let bank = estrattoConto.value.type_pay_mode_name
      let desc = estrattoConto.value.descrizione.toLowerCase()
      let tot_fatt = desc.split('n.').pop().split('inc')[0]
      let n = !isNaN(tot_fatt) ? parseInt(tot_fatt) : 0

      if (payments.value.length > 0 && payments.value.length >= n && (payments.value.length - n) <= 6 && bank == 'MPS') {
        diffLength.value = Math.abs(payments.value.length - n)
        // getCombinationsRid()
        return true
      }

      return false
    };

    const getRidsToDiscard = () => {
      combinations.value = [] 
      let total_payments = payments.value.reduce((acc, curr) =>  acc + curr.value, 0).toFixed(2)
      let diffTotal = (Math.abs(estrattoConto.value.value - total_payments)).toFixed(2)
      comboFromReverse(diffTotal, diffLength.value)
    }

    const comboFromReverse = (t, l) => {

      let tot = parseFloat(t)
      let length = parseInt(l)

      const arr = []
      payments.value.forEach(el => {
        if (el.value <= tot) {
          arr.push(el)
        }
      });
      getPermutations(arr, length).forEach(a => {
        let sum = a.reduce((sum, el) => sum + el.value, 0).toFixed(2);

        if (sum == tot) {
          combinations.value.push(payments.value.filter(x => !a.includes(x)));
        }
      });

      function getPermutations (array, length) {
          return array.flatMap((v, i) => length > 1
              ? getPermutations(array.slice(i + 1), length - 1).map(w => [v, ...w])
              : [[v]]
          );
      }      
    }

    // const getCommonPayments = () => {
    //   let arr = []
    //   combinations.value.forEach(c => {
    //     let v = payments.value.filter(el => !c.includes(el))

    //     v.forEach(a => {
    //       arr.push(a.numero) 
    //     });
        
    //   })
    //   const common = arr.filter((item, index) => index !== arr.indexOf(item));
    //   console.log(common);
    // }


    const filterTypeFlusso = () => {
      if (payments.value.length > 0) {
        selectedPayments.value = []
        selectedPayments.value = payments.value.filter( el => selectedTypeFlusso.value.includes( el.flusso.split(' - ')[1] ) )
      }
    }

    const selectedSum = computed(() => {
        return selectedPayments.value.reduce((old, el) =>  Math.abs(old) +  Math.abs(el.value), 0)
    })

    const percentage = computed(() => {
        return ((100 * Math.abs(selectedSum.value)) / Math.abs(estrattoConto.value.value)).toFixed(2)
    })

    const associa = () => {
        const obj = {...estrattoConto.value}
        obj.payments = selectedPayments.value
        service.associateToRids(obj).then((res)=> {
          if (res) {
            emit('movement-regularized',{id: estrattoConto.value.id})
          }
        }) 
    }

    const handleFileUpload = (evt) => {
      fileToUpload.value = []
      checkResult.value = null
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }

    const checkPreImport = async () => {
      submitted.value = true
      checkResult.value = null
      checkDialog.value = false
      if (!validateFile()) {
        return
      }

      loader.value = true
      try {
        const res = await service.checkPreImportEstrattoconto(fileToUpload.value[0])
        if (res?.items) {
          const items = res.items
          if (items.non_ok?.length) {
            items.non_ok = items.non_ok.map((row) => ({
              ...row,
              cod_estrattoconto: getCodEstrattoconto(row),
            }))
          }
          checkResult.value = items
          if (items.message && !items.totals) {
            self.$eventBus.emit('data-load-error', { message: items.message })
            return
          }
          checkActiveTab.value = (items.non_ok?.length > 0) ? 'non_ok' : 'ok'
          checkDialog.value = true
        }
      } finally {
        loader.value = false
      }
    }

    const getCodEstrattoconto = (row) => {
      if (!row) return null
      if (row.cod_estrattoconto != null && row.cod_estrattoconto !== '' && Number(row.cod_estrattoconto) !== 0) {
        return row.cod_estrattoconto
      }
      if (row.cod_estratto_conto != null && row.cod_estratto_conto !== '' && Number(row.cod_estratto_conto) !== 0) {
        return row.cod_estratto_conto
      }
      if (Array.isArray(row.motivi)) {
        for (const motivo of row.motivi) {
          const match = String(motivo).match(/cod_estrattoconto già valorizzato \(trovato:\s*([^)]+)\)/i)
          if (match?.[1]) {
            const value = match[1].trim()
            if (value && value !== '0' && value.toLowerCase() !== 'null') {
              return value
            }
          }
        }
      }
      return null
    }

    const formatMotivo = (motivo) => {
      const text = String(motivo || '')
      if (/cod_estrattoconto già valorizzato/i.test(text)) {
        return 'Estratto conto già trovato'
      }
      if (/Nessun pagamento trovato in payments/i.test(text)) {
        return 'Nessun pagamento trovato'
      }
      if (/Numero fattura non trovato nella descrizione/i.test(text)) {
        return 'Numero fattura non trovato nella descrizione'
      }
      if (/cod_type_pay diverso da 3/i.test(text)) {
        return 'Tipo pagamento non valido'
      }
      if (/note non contiene ADDEBITO SDD/i.test(text)) {
        return 'Note senza ADDEBITO SDD'
      }
      return text
    }

    const getMotivoSeverity = (motivo) => {
      if (/cod_estrattoconto già valorizzato/i.test(String(motivo || ''))) {
        return 'warning'
      }
      return 'danger'
    }

    const goToEstrattoConto = (row) => {
      const cod = getCodEstrattoconto(row)
      if (!cod) return
      window.open(`/estratti-conto/detail/regularized/${cod}`, '_blank')
    }

    const onNonOkRowClick = (event) => {
      if (getCodEstrattoconto(event.data)) {
        goToEstrattoConto(event.data)
      }
    }

    const nonOkRowClass = (data) => {
      return getCodEstrattoconto(data) ? 'cursor-pointer row-has-estratto' : ''
    }

    const selectedSameItemsIntoFile = async () => {
      submitted.value = true
      if (!validateFile()) return

      loadingFile.value = true
      try {
        const data = await fileToUpload.value[0].arrayBuffer();
        const workbook = XLSX.read(data);
        let first_sheet_name = workbook.SheetNames[0];
        let ws = workbook.Sheets[first_sheet_name];
        const sheet = XLSX.utils.sheet_to_json(ws, {skipHeader:true});
        let numeriFattura = []
        if (sheet.length > 0) {
          sheet.forEach(row => {
            if ('Descrizione Operazione' in row) {
              numeriFattura.push(row['Descrizione Operazione'].replace('Fattura','').replace(' ',''));
            }
          });
          selectedPayments.value = payments.value.filter(el =>  numeriFattura.includes(el.numero))
          keyResetInput.value = new Date()
        }
        toast.add({
          severity: selectedPayments.value.length > 0 ? 'success' : 'warn',
          summary: 'File elaborato',
          detail: `Fatture trovate nel file: ${numeriFattura.length}. Selezionate nella DataTable: ${selectedPayments.value.length}.`,
          life: 5000
        })
      } finally {
        loadingFile.value = false
      }
    }

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    const validateFile = () => {
      validationErrors.value = [];

      if (fileToUpload.value.length == 0) {
        validationErrors.value['files'] = true;
        delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => Object.values(allowedType).includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      console.log(validationErrors.value)
      return !Object.keys(validationErrors.value).length;
    }
    
    return {
      dt,
      loader,
      validationErrors,
      submitted,
      filters, 
      estrattoConto,
      getData,
      payments,
      originalPayments,
      selectedPayments,
      percentage,
      selectedSum,
      periodo_riferimento,
      associa,
      changeData,
      getCombinationsRid,
      combinations,
      injectCombo,
      selectedTypeFlusso,
      filterTypeFlusso,
      isVisibleReverseBox,
      getRidsToDiscard,
      handleFileUpload,
      fileToUpload,
      keyResetInput,
      allowedType,
      checkPreImport,
      checkResult,
      checkDialog,
      checkActiveTab,
      loadingFile,
      getCodEstrattoconto,
      formatMotivo,
      getMotivoSeverity,
      goToEstrattoConto,
      onNonOkRowClick,
      nonOkRowClass,
      selectedSameItemsIntoFile,
      // getCommonPayments,
      exportCSV
    }
  },
}
</script>

<style scoped>
button:disabled,
button[disabled]{
  opacity: 0.3 !important;
}
.chip-selected-suggest {
  overflow-y: scroll;
  max-height: 400px;
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

:deep(.row-has-estratto) {
  cursor: pointer;
}
:deep(.row-has-estratto:hover) {
  background-color: #f4f1ea !important;
}

.check-dialog {
  --check-ink: #2f3437;
  --check-muted: #787774;
  --check-line: #eaeaea;
  --check-bone: #f7f6f3;
  --check-ok-bg: #edf3ec;
  --check-ok-fg: #346538;
  --check-ko-bg: #fdebec;
  --check-ko-fg: #9f2f2d;
  --check-warn-bg: #fbf3db;
  --check-warn-fg: #956400;
  color: var(--check-ink);
  animation: check-dialog-in 0.45s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes check-dialog-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.check-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.check-dialog__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--check-muted);
  font-weight: 600;
}

.check-dialog__title {
  margin: 0;
  font-size: 1.45rem;
  letter-spacing: -0.03em;
  line-height: 1.15;
  font-weight: 650;
  color: var(--check-ink);
}

.check-dialog__subtitle {
  margin: 0.45rem 0 0;
  max-width: 42ch;
  color: var(--check-muted);
  font-size: 0.92rem;
  line-height: 1.45;
}

.check-dialog__close {
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--check-line);
  border-radius: 8px;
  background: #fff;
  color: var(--check-muted);
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), background-color 0.2s ease, color 0.2s ease;
}

.check-dialog__close:hover {
  background: var(--check-bone);
  color: var(--check-ink);
}

.check-dialog__close:active {
  transform: scale(0.96);
}

.check-dialog__stats {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

@media (max-width: 768px) {
  .check-dialog__stats {
    grid-template-columns: 1fr;
  }
}

.check-stat {
  border: 1px solid var(--check-line);
  border-radius: 10px;
  padding: 0.95rem 1rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-height: 100%;
}

.check-stat--hero {
  background: linear-gradient(160deg, #fbfbfa 0%, #edf3ec 100%);
}

.check-stat__label {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--check-muted);
  font-weight: 600;
}

.check-stat__value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 1.85rem;
  letter-spacing: -0.04em;
  line-height: 1.1;
  font-weight: 650;
}

.check-stat--ok .check-stat__value { color: var(--check-ok-fg); }
.check-stat--ko .check-stat__value { color: var(--check-ko-fg); }
.check-stat--total .check-stat__value { color: var(--check-ink); }

.check-stat__hint {
  font-size: 0.8rem;
  color: var(--check-muted);
  line-height: 1.35;
}

.check-dialog__tabs {
  display: inline-flex;
  gap: 0.35rem;
  padding: 0.3rem;
  border: 1px solid var(--check-line);
  border-radius: 10px;
  background: var(--check-bone);
  margin-bottom: 1rem;
}

.check-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border: 0;
  background: transparent;
  color: var(--check-muted);
  padding: 0.55rem 0.9rem;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}

.check-tab:active {
  transform: scale(0.98);
}

.check-tab.is-active {
  background: #fff;
  color: var(--check-ink);
  box-shadow: 0 1px 2px rgba(47, 52, 55, 0.06);
}

.check-tab__dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 999px;
}

.check-tab__dot--ok { background: var(--check-ok-fg); }
.check-tab__dot--ko { background: var(--check-ko-fg); }

.check-tab__count {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  min-width: 1.4rem;
  text-align: center;
  padding: 0.1rem 0.35rem;
  border-radius: 999px;
  background: rgba(47, 52, 55, 0.06);
}

.check-dialog__panel {
  min-height: 280px;
}

.check-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.85rem;
  letter-spacing: -0.02em;
}

.check-muted {
  color: var(--check-muted);
}

.check-ec-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: transparent;
  color: #1f6c9f;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.85rem;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.check-ec-link:hover {
  color: #15557d;
}

.check-motivi {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.check-motivo {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  line-height: 1.3;
}

.check-motivo--danger {
  background: var(--check-ko-bg);
  color: var(--check-ko-fg);
}

.check-motivo--warning {
  background: var(--check-warn-bg);
  color: var(--check-warn-fg);
}

.check-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: 260px;
  padding: 1.5rem;
  border: 1px dashed var(--check-line);
  border-radius: 12px;
  background: var(--check-bone);
}

.check-empty__icon {
  font-size: 1.4rem;
  color: var(--check-muted);
  margin-bottom: 0.75rem;
}

.check-empty__icon--ok {
  color: var(--check-ok-fg);
}

.check-empty__title {
  margin: 0;
  font-size: 1.05rem;
  letter-spacing: -0.02em;
  font-weight: 650;
}

.check-empty__text {
  margin: 0.35rem 0 0;
  color: var(--check-muted);
  max-width: 42ch;
  line-height: 1.45;
}

.check-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.1rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--check-line);
}

.check-dialog__footer-hint {
  margin: 0;
  color: var(--check-muted);
  font-size: 0.82rem;
}

.check-dialog__close-btn {
  border-color: var(--check-line) !important;
  color: var(--check-ink) !important;
}

:deep(.check-table .p-datatable-thead > tr > th) {
  background: var(--check-bone) !important;
  color: var(--check-muted) !important;
  font-size: 0.72rem !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 650 !important;
  border-color: var(--check-line) !important;
}

:deep(.check-table .p-datatable-tbody > tr > td) {
  border-color: var(--check-line) !important;
  font-size: 0.88rem;
}

:deep(.check-table .p-paginator) {
  border: 0 !important;
  padding-top: 0.75rem !important;
  background: transparent !important;
}

@media (max-width: 768px) {
  .check-dialog__footer {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>

<style>
/* Dialog teleporta fuori dal componente: override non scoped */
.check-pre-import-dialog.p-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid #eaeaea !important;
  box-shadow: 0 18px 50px rgba(47, 52, 55, 0.12) !important;
}

.check-pre-import-dialog .p-dialog-content,
.check-pre-import-dialog .check-dialog-content {
  padding: 1.35rem 1.5rem 1.15rem !important;
  background: #fff !important;
}

.check-pre-import-dialog .p-dialog-header {
  display: none !important;
}
</style>
